define('views/modules/conversation/lists/conversation-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'collections/member/supervisors',
    // views
    'views/parts/list/fetch-list',
    'views/modules/conversation/lists/conversation-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    Supervisors,
    // views
    VFetchList,
    VConversationListItem
) {

    var VConversationList = VFetchList.extend({
        item: VConversationListItem,

        initialize: function(opt) {
            VConversationList.__super__.initialize.call(this, opt);
        },

        getItemOptions: function(options) {
            return _.extend(options, {
                supervisors: Supervisors,
            }, _.pick(this.options, ['profile', 'folder']));
        },
    });

    return VConversationList;

});

